






















































































































































































import { Vue, Component } from "vue-property-decorator";
import {
  getActivityRosterListApi,
  exportActivityRosterListApi,
  getMarketStaffListApi,
  getActivityRosterHeaderListApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "viewList",
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    commit_status: -1,
  };
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tableData: any[] = [];
  market_staff_list: any[] = [];
  itemRosterTitle: any[] = [];
  is_pay: any = "";
  timer: any = "";
  effectiveDate: any = {
    disabledDate(date: any) {
      return date.getTime() > Date.now();
    },
  };
  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    this.getActivityRosterHeaderList();
    this.getMarketStaffListApiFn();
    this.is_pay = this.$route.query.is_pay;
  }
  solveSearchInfo(option: any) {
    let params = { ...option };
    if (this.$route.query.activity_id) {
      params.activity_id = this.$route.query.activity_id;
    }
    if (this.searchInfo.keyword) {
      params.keyword = this.searchInfo.keyword;
    }
    if (this.searchInfo.market_staff_id) {
      params.market_staff_id = this.searchInfo.market_staff_id;
    }
    if (this.searchInfo.create_time) {
      params.create_start_time =
        new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() / 1000;
      params.create_end_time =
        new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() / 1000;
    }
    if (this.searchInfo.commit_status > 0) {
      params.commit_status = this.searchInfo.commit_status;
    }
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    getActivityRosterListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any, index: any) => {
          item.paid_amount = item.paid_amount === "" ? "-" : item.paid_amount;
          item.create_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(item.create_time * 1000)
          );
          item.roster_form_list.forEach((it: any, index: any) => {
            // 找到多选类型的数据，只有多选类型会返回带 [] 的数据
            if (
              it.activity_form.preset_form_id > 5 &&
              it.activity_form.type === 3
            ) {
              // 多选的数据为空
              if (it.form_value.includes("[]")) {
                it.form_value = "-";
              } else {
                // 数据转换
                it.form_value = JSON.parse(it.form_value).join(",");
              }
            }
          });
          let arr: any[] = [];
          // 将数据全部默认赋值为空（后端只返回有数据的，会导致展示错乱）
          this.itemRosterTitle.forEach((it: any, index: any) => {
            arr.push({
              activity_form: {
                preset_form_id: this.itemRosterTitle[index].preset_form_id,
                title: this.itemRosterTitle[index].title,
                type: this.itemRosterTitle[index].type,
                form_id: this.itemRosterTitle[index].form_id,
              },
              form_value: "-",
            });
          });
          // 将有数据的重新复赋值，避免错乱
          arr.forEach((it: any) => {
            item.roster_form_list.forEach((i: any) => {
              if (
                it.activity_form.preset_form_id ===
                i.activity_form.preset_form_id
              ) {
                it.form_value = i.form_value;
                it.activity_form = i.activity_form;
              }
            });
          });
          item.roster_form_list = arr;
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  getActivityRosterHeaderList() {
    getActivityRosterHeaderListApi({
      activity_id: Number(this.$route.query.activity_id),
    }).then((res: any) => {
      if (res.error_code === 0) {
        // 过滤出不带姓名和手机号的表头
        this.itemRosterTitle = res.data.list
          .filter((item: any) => {
            if (item.preset_form_id !== 1) {
              return item;
            }
          })
          .filter((item: any) => {
            if (item.preset_form_id !== 4) {
              return item;
            }
          });
      }
    });
  }
  // 获取市场顾问列表
  getMarketStaffListApiFn(v?: any) {
    getMarketStaffListApi({
      page: 1,
      page_size: 100,
      keyword: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.market_staff_list = res.data.list;
      }
    });
  }

  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  // 模糊搜索 - 市场顾问
  handleSearchMarketStaff(v: any) {
    this.debounce(this.getMarketStaffListApiFn, v, 500);
  }
  debounce(fn: any, data: any, delay: any) {
    // 设置一个触发开关
    let _t = this;
    clearTimeout(_t.timer);
    _t.timer = setTimeout(() => {
      fn(data);
    }, delay);
  }
  handleExport() {
    let option = this.solveSearchInfo({
      page: this.page,
      page_size: this.pageSize,
    });
    exportActivityRosterListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      }
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  handleBack() {
    this.$router.push({
      name: "activityManagement",
    });
  }
}
